import { render, staticRenderFns } from "./networks.vue?vue&type=template&id=13a227ec&scoped=true"
import script from "./networks.vue?vue&type=script&lang=js"
export * from "./networks.vue?vue&type=script&lang=js"
import style0 from "./networks.vue?vue&type=style&index=0&id=13a227ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a227ec",
  null
  
)

export default component.exports